<template>
  <div class="strip">
    <div class="strip__image">
      <img :src="form.url" :alt="form.caption">
      <upload-strip-image label="Replace Image" @complete="replace"/>
    </div>
    <div class="strip__form">
      <div class="strip__banner" v-if="showBanner">
        🚧 Confirm details and save
      </div>
      <form class="form">
        <div class="form__group">
          <text-input label="Number" v-model="form.number" :disabled="!!number" />
        </div>
        <div class="form__group">
          <text-input type="date" label="Date" v-model="form.publishDate" :required="true" />
        </div>
        <div class="form__group">
          <text-input label="Name" v-model="form.name" :required="true" />
        </div>
        <div class="form__group">
          <rich-text-input label="Caption" v-model="form.caption" :simple="true" />
        </div>
        <div class="form__group">
          <select-input label="Publish" :options="publishOptions" v-model="form.free" />
        </div>
        <div class="form__submit">
          <button :disabled="disabled || !formIsValid" @click.prevent="submit">
            Save
          </button>
          <button
            @click.prevent="remove"
            class="is-light"
            :disabled="disabled"
          >
            Delete
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { database } from '@/firebase';
import { DATEFORMAT } from '@/utilities/time';
import publishOptions from '@/utilities/publishOptions';
import TextInput from '@/components/TextInput.vue';
import RichTextInput from '@/components/RichTextInput.vue';
import SelectInput from '@/components/SelectInput.vue';
import UploadStripImage from './UploadStripImage.vue';

export default {
  name: 'StripForm',
  components: {
    TextInput,
    RichTextInput,
    SelectInput,
    UploadStripImage,
  },
  props: {
    id: String,
    number: Number,
    name: String,
    free: Boolean,
    caption: String,
    publishDate: Object,
    likeCount: Number,
    url: String,
    disabled: Boolean,
    showBanner: Boolean,
  },
  watch: {
    $route() {
      this.setForm();
    },
  },
  data() {
    return {
      form: {},
      publishOptions,
    };
  },
  computed: {
    formIsValid() {
      const { number, name, publishDate } = this.form;
      return number && name && dayjs(publishDate).isValid();
    },
  },
  created() {
    this.setForm();
  },
  methods: {
    setForm() {
      const { $props } = this;
      this.form = {
        url: $props.url,
        number: $props.number,
        publishDate: this.formatDate($props.publishDate),
        name: $props.name || '',
        caption: $props.caption || '',
        free: $props.free === undefined ? true : $props.free,
      };
    },
    formatDate(publishDate) {
      return publishDate && dayjs.unix(publishDate.seconds).format(DATEFORMAT);
    },
    replace({ images }) {
      const { number } = this.form;
      this.$emit('submit', {
        number,
        ...images,
      });
    },
    submit() {
      const formValue = { ...this.form };
      const { getTimestamp } = database;
      const roundedDate = dayjs(formValue.publishDate).startOf('day').toDate();
      formValue.publishDate = getTimestamp(roundedDate);
      this.$emit('submit', formValue);
    },
    remove() {
      this.$emit('remove', this.form.number);
    },
  },
};
</script>

<style lang="scss" scoped>
.strip {
  width: 700px;
  margin: 0 auto;
  display: flex;
  @media all and (max-width: 700px) {
    padding: 20px;
    display: block;
  }
  &__banner {
    border: solid 2px var(--color-link-inactive);
    padding: 10px 15px;
    border-radius: var(--radius);
    margin-bottom: 20px;
  }
  &__image {
    width: 340px;
    margin: 0 50px 0 0;
    position: relative;
    img {
      max-width: 100%;
      border: solid 2px var(--color-dark);
    }
    @media all and (max-width: 700px) {
      width: 100%;
    }
  }
  &__form {
    flex: 1;
  }
}

.form {
  &__group {
    margin-bottom: 10px;
  }
  &__submit {
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
  }
}
</style>
